import { FunctionComponent } from 'react';
import Link from 'next/link';
import PaginationWrapper from './pagination.style';
import ArrowIcon from '../../public/icon/Arrow';

type PaginstaionType = {
  totalCount: number;
  isMobile: boolean;
  pageCount: number;
  urlpath: string;
  currentPage: number;
};
const Pagination: FunctionComponent<PaginstaionType> = ({
  isMobile = 10,
  totalCount,
  pageCount,
  urlpath,
  currentPage,
}) => {
  const numberUnit = isMobile ? 5 : 10;
  const pageCnt = Math.ceil(totalCount / pageCount);
  let pRCnt = parseInt((currentPage / numberUnit).toString(), 0);
  if (currentPage % numberUnit === 0) {
    pRCnt = parseInt((currentPage / (numberUnit - 1)).toString(), 0);
  }
  const startPage = pRCnt * numberUnit + 1;
  const limitNumber = Math.min(pageCnt, (pRCnt + 1) * numberUnit);

  const pageNumberGroup = [];
  for (let index = startPage; index <= limitNumber; index += 1) {
    pageNumberGroup.push(
      <Link href={{ pathname: urlpath, query: { page: index } }} key={index}>
        <a className={`pagination--number ${index === currentPage ? 'active' : ''}`} key={index}>
          {index}
        </a>
      </Link>,
    );
  }

  return (
    <PaginationWrapper>
      {currentPage > numberUnit && (
        <div className="pagination--arrow left mobile">
          <ArrowIcon width="25px" height="25px" />
        </div>
      )}
      {currentPage > 1 && (
        <Link href={{ pathname: urlpath, query: { page: currentPage - 1 } }}>
          <a className="arrow-desktop-wrap desktop">
            <div className="arrow-desktop">
              <div className="pagination--arrow left">
                <ArrowIcon />
              </div>
              이전페이지
            </div>
          </a>
        </Link>
      )}
      <div className="pagination--numbers">{pageNumberGroup}</div>
      {startPage + numberUnit < pageCnt && (
        <Link href={{ pathname: urlpath, query: { page: startPage + numberUnit } }}>
          <div className="pagination--arrow right mobile">
            <ArrowIcon width="25px" height="25px" />
          </div>
        </Link>
      )}
      {currentPage < pageCnt && (
        <Link href={{ pathname: urlpath, query: { page: currentPage + 1 } }}>
          <a className="arrow-desktop-wrap desktop right">
            <div className="arrow-desktop">
              다음페이지
              <div className="pagination--arrow right">
                <ArrowIcon />
              </div>
            </div>
          </a>
        </Link>
      )}
    </PaginationWrapper>
  );
};

export default Pagination;
